import { render, staticRenderFns } from "./ObiAdCard.vue?vue&type=template&id=b1a8b328&scoped=true&"
import script from "./ObiAdCard.vue?vue&type=script&lang=js&"
export * from "./ObiAdCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiAdCard.vue?vue&type=style&index=0&id=b1a8b328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8b328",
  null
  
)

export default component.exports